import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { SharedNavBar, NavData } from 'Guide/PageNavigation/SharedNavBar';

export function AnswersNav(props: NavData) {
   const { breadCrumbs, navTabs } = props;

   return <SharedNavBar breadCrumbs={breadCrumbs} navTabs={navTabs} />;
}

initializeChakraComponent('AnswersNavComponent', AnswersNav);
